import * as queryString from "query-string";
import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { PromotionCodesSuccessResponse } from "./api-response/PromotionCodesSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { map } from "rxjs/operators";

export class ApiPromotionCode {
  constructor(private apiEndpoint: string) {}

  listForOrganization(
    token: string,
    organization: OrganizationKeyName,
    page: number,
    filters: { [i: string]: string }
  ): Observable<PromotionCodesSuccessResponse> {
    const params = queryString.stringify(
      {
        page,
        ...(filters || {}),
      },
      { arrayFormat: "bracket" }
    );

    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/promotion-code?${params}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
